import { Component } from "@angular/core";

import { SvgMixinLargeComponent } from "../svg-large-mixin.component";

@Component({
  selector: "med-icon-map-pin",
  templateUrl: "./med-icon-map-pin.component.html",
})
export class MedIconMapPinComponent extends SvgMixinLargeComponent { }
